<script>
import ReportsRequest from 'Modules/contacard/reports/reports/ReportsRequest';
import ReportConfirmMangerModalVue from '@/app/arch/components/modals/ReportConfirmMangerModal.vue';

export default {
  name: 'StatementTerminateBtn',
  extends: ReportConfirmMangerModalVue,
  data: () => ({
    requestClass: ReportsRequest,
    totalItens: 0,
    btnText: 'Exportar transações',
    successMessage: 'Transações exportadas com sucesso!',
    crudListName: 'StatementsCrudList',
  }),
};
</script>
